import { IResponseState } from '../../../components/Modals/ResponseModal/module/constants'
import { STATE_IDENTIFIER } from './constants'

const {
  CALL_STATE,
  PWD_POLICY,
  TEMP_TOKEN,
  TEMP_TOKEN_TYPE,
  UIGP_OTP_RECEIVER,
  AUTH_RESPONSE_ERROR,
} = STATE_IDENTIFIER

const emptyState = {
  [CALL_STATE]: IResponseState.PENDING,
  [TEMP_TOKEN]: '',
  [TEMP_TOKEN_TYPE]: '',
  [AUTH_RESPONSE_ERROR]: false,
  [PWD_POLICY]: null,
  [UIGP_OTP_RECEIVER]: '',
}

export default emptyState
